import React from 'react';
import { Anchor, Box, Button, Group } from '@mantine/core';
import { IActionButton, IconTooltip, StrikethroughIcon } from '../../../ui-atoms';
import useGlobalCustomStyles from '../../../../useGlobalCustomStyles';

const ActionButtonInline = ({ actions }: IActionButton) => {
  const { classes } = useGlobalCustomStyles();
  return (
    <Group spacing="xs">
      {actions.map((action, index: number) => {
        if ('excelButtonComponent' in action) {
          const {
            excelButtonComponent: ExcelButtonComp,
            currentPageDataUrl,
            allPageDataUrl,
            fileTitle,
            getTranslatedHeader,
            isPOC,
          } = action;
          return (
            <ExcelButtonComp
              key={`${index.toString()}_button`}
              currentPageDataUrl={currentPageDataUrl}
              allPageDataUrl={allPageDataUrl}
              fileTitle={fileTitle}
              getTranslatedHeader={getTranslatedHeader}
              isPOC={isPOC}
            />
          );
        }

        if ('excelButtonComponent2' in action) {
          const {
            excelButtonComponent2: ExcelButtonComp,
            currentPageDataUrl,
            allDataUrl,
            fileTitle,
            exportStructure,
            exportAllDataStructure,
          } = action;
          return (
            <ExcelButtonComp
              key={`${index.toString()}_button`}
              currentPageDataUrl={currentPageDataUrl}
              fileTitle={fileTitle}
              exportStructure={exportStructure}
              allDataUrl={allDataUrl}
              exportAllDataStructure={exportAllDataStructure}
            />
          );
        }

        if ('displayWarning' in action) {
          return (
            <Box
              key={`${index.toString()}_button`}
              {...(action.displayWarning && { sx: { display: 'flex', alignItems: 'center' } })}
            >
              {action.displayWarning && action.warningText}
            </Box>
          );
        }

        if (action.isHidden) {
          return null;
        }

        const Icon = action.icon;
        return (
          <Box
            key={`${index.toString()}_button`}
            {...(action.displayOptionalText && { sx: { display: 'flex', alignItems: 'center' } })}
          >
            {!action.buttonLabel ? (
              <Anchor
                {...(action.ariaLabelText && { 'aria-label': action.ariaLabelText })}
                className={
                  action.isDisabled ? classes.actionIconDisabled : classes.actionIconEnabled
                }
                component="button"
                disabled={action.isDisabled}
                onClick={() => action.callBack()}
              >
                <IconTooltip label={action.toolTipLabel} withArrow>
                  {Icon && <StrikethroughIcon icon={Icon} isStrikethrough />}
                </IconTooltip>
              </Anchor>
            ) : (
              <Button
                key={`${index.toString()}_button`}
                leftIcon={Icon && <Icon size={18} />}
                disabled={action.isDisabled}
                size="xs"
                color="blue.6"
                variant={action.variant ?? 'filled'}
                onClick={() => action.callBack()}
              >
                {action.buttonLabel}
              </Button>
            )}
            {action.displayOptionalText && action.optionalText}
          </Box>
        );
      }, [])}
    </Group>
  );
};

export default ActionButtonInline;
